import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpService } from 'src/app/https.service';
import { URLUtils } from 'src/app/urlUtils';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { HttpErrorResponse } from '@angular/common/http';
import { interval, of } from 'rxjs';
import { switchMap, catchError, takeWhile, delayWhen } from 'rxjs/operators';

@Component({
    selector: 'app-upload-file-modal',
    templateUrl: './upload-file-modal.component.html',
    styleUrls: ['./upload-file-modal.component.css'],
    standalone: false
})
export class UploadFileModalComponent {

  @ViewChild('fileInput') fileInput!: ElementRef;
  files: File[] = [];
  parsedData: any[] = [];
  dragActive = false;
  uid:any;
  repz:any;
  constructor(public activeModal: NgbActiveModal,private spinner: NgxSpinnerService,private httpService: HttpService,private toastr: ToastrService) { }
  
  onFileChange(event: any) {
    const selectedFiles = event.target.files;
    if (selectedFiles.length > 0) {
      this.processFiles(selectedFiles);
    }
  }
  
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragActive = true;
  }
  
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragActive = false;
  }
  
  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragActive = false;
    
    if (event.dataTransfer?.files) {
      this.processFiles(event.dataTransfer.files);
    }
  }
  
  browseFiles() {
    this.fileInput.nativeElement.click();
  }
  
  processFiles(fileList: FileList) {
    if (this.files.length + fileList.length > 5) {
      alert('You can upload up to 5 files maximum');
      return;
    }
    
    Array.from(fileList).forEach(file => {
      if (file.type === 'text/csv' || file.name.endsWith('.csv')) {
        this.files.push(file);
        this.readCSVFile(file);
      } else {
        alert('Only CSV files are supported');
      }
    });
  }
  
  readCSVFile(file: File) {
    const reader = new FileReader();
    reader.readAsText(file);
    
    reader.onload = () => {
      const csvData = reader.result as string;
      const parsedData = this.parseCSV(csvData);
      this.parsedData = [...this.parsedData, ...parsedData];
    };
    
    reader.onerror = () => {
      console.error('Error reading file');
    };
  }
  
  parseCSV(csvData: string): any[] {
    const lines = csvData.split('\n');
    const result = [];
    const headers = lines[0].split(',').map(header => header.trim());
    
    for (let i = 1; i < lines.length; i++) {
      const line = lines[i].trim();
      if (!line) continue;
      
      const obj: any = {};
      const currentLine = line.split(',');
      
      for (let j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentLine[j]?.trim() || '';
      }
      
      result.push(obj);
    }
    
    return result;
  }
  
  removeFile(index: number) {
    // Remove the corresponding parsed data as well
    // This is simplified logic; in a real app you might need more complex tracking
    const removedFile = this.files[index];
    this.files.splice(index, 1);
    
    // Reset parsed data if all files are removed
    if (this.files.length === 0) {
      this.parsedData = [];
    }
  }
  
  // importLeads() {
  //   // if (this.parsedData.length > 0) {
  //   //   this.activeModal.close(this.parsedData);
  //   // } else {
  //   //   this.activeModal.dismiss('No data');
  //   // }
  //   //console.log('Imported leads:', this.files);
  //   this.files.forEach(file => {
  //     //console.log('File:', file.name);  
  //     let fdata = new FormData();
  //     fdata.append('file', file);
  //     this.spinner.show();
  //     this.uid = localStorage.getItem('profuid');

  //     this.httpService.sendRePostRequest(URLUtils.csvtoleads(this.uid), fdata).subscribe({
  //       next: (res: any) => {
  //         this.spinner.hide();

  //         this.httpService.sendReGetRequest(URLUtils.csvFileKey(res.key)).subscribe({
  //           next: (resp: any) => {
  //             // console.log('filekey', resp)
  //             if (!res.error) {
  //               // console.log('Success:', res);
  //               this.toastr.success(res.msg);
  //               this.activeModal.close(res);
  //             }
  //             else if (res.error) {
  //               this.toastr.error(res.msg);
  //               this.activeModal.close(res);
  //             }
  //             else {
  //               this.toastr.error('Internal Server Error');
  //             }

  //           }
  //         });

  //       },
  //       error: (error: HttpErrorResponse) => {
  //         this.spinner.hide();
  //         let errorMessage = 'Something went wrong.';
  //         if (error.status === 500) {
  //           errorMessage = error.error?.msg || 'Internal Server Error';
  //         } else if (error.status === 401 || error.status === 403) {
  //           errorMessage = error.error?.msg || 'Unauthorized';
  //         }
  //         this.toastr.error(errorMessage);
  //         console.error('Error submitting lead:', error);
  //       }
  //     });
  //   })    
  // }


  importLeads() {
    this.files.forEach(file => {
      const fdata = new FormData();
      fdata.append('file', file);
      this.spinner.show();
      this.uid = localStorage.getItem('profuid');

      this.httpService.sendRePostRequest(URLUtils.csvtoleads(this.uid), fdata).subscribe({
        next: (res: any) => {
          const fileKeyUrl = URLUtils.csvFileKey(res.key);

          interval(2000).pipe(
            switchMap(() =>
              this.httpService.sendReGetRequest(fileKeyUrl).pipe(
                //catchError(() => of(null)) // catch single poll error
                 catchError((err) => of(err.error)) // preserves error content for toast
              )
            ),
            takeWhile((respo: any) => {
              // Keep polling while: - No response yet - AND not success (status !== 200 || error is true)
              //return !respo || (respo.status !== 200 && respo?.error !== true);

              return !respo || (
                (respo?.error !== true && respo?.error !== false) ||
                (respo?.error === false && respo?.msg === 'Still processing or expired.')
              );
            }, true) // emit the last one that breaks the loop
          ).subscribe({
            // next: (resp: any) => {
            //   this.spinner.hide();
            //   if (resp?.error === false) {
            //     //this.toastr.success(resp.msg);
            //     if (resp.msg !== 'Still processing or expired.') {
            //       this.toastr.success(resp.msg);
            //     }
            //     this.activeModal.close(resp);
            //   }
            //   else if (resp?.error === true) {
            //     const errorList = resp.data?.errors;
            //     if (Array.isArray(errorList) && errorList.length) {
            //       errorList.forEach((e: any) => {
            //         const msg = `${e.field}: ${e.msg}`;
            //         this.toastr.error(msg);
            //       });
            //     } else {
            //       this.toastr.error(resp.msg || 'Something went wrong.');
            //     }
            //     this.activeModal.close(resp);
            //   }

            //   this.activeModal.close(resp);
            // },

              next: (resp: any) => {
                this.spinner.hide();

                if (resp?.error === false) {
                  if (resp.msg !== 'Still processing or expired.') {
                    this.toastr.success(resp.msg);
                  }
                  this.activeModal.close(resp);
                }
                else if (resp?.error === true) {
                  const errorList = resp.data?.errors;
                  if (Array.isArray(errorList) && errorList.length) {
                    errorList.forEach((e: any) => {
                      const msg = `${e.field}: ${e.msg}`;
                      this.toastr.error(msg);
                    });
                  } else {
                    this.toastr.error(resp.msg || 'Something went wrong.');
                  }
                  this.activeModal.close(resp);
                }
              },
            error: (err) => {
              this.spinner.hide();
              this.toastr.error('Polling failed. Please try again later.');
              console.error(err);
            }
          });

        },
        error: (error: HttpErrorResponse) => {
          console.log('err', error)
          this.spinner.hide();
          let errorMessage = 'Something went wrong.';
          if (error.status === 500) {
            errorMessage = error.error?.msg || 'Internal Server Error';
          } else if (error.status === 401 || error.status === 403) {
            errorMessage = error.error?.msg || 'Unauthorized';
          }
          this.toastr.error(errorMessage);
          console.error('Error submitting lead:', error);
        }
      });
    });
  }
  
  cancel() {
    this.activeModal.dismiss('Cancelled');
  }

}
